module.exports = __webpack_public_path__ + "/login_ui/img/eg-98d46460499de8ee2642438afa408cb9.svg";